const formMaintenance = {
  formTitleCreate: 'Registrar nuevo Mantenimiento',
  formTitleEdit: 'Detalles de mantenimiento',
  optionsLabel: 'Opciones',
  optionsMsg: 'Editar / Eliminar Manutención',
  identifier: 'identificador',
  description: 'Descripción',
  value: 'Valor',
  company: 'Empresa Responsable',
  sendToMaintenanceDate: 'Fecha de envío prevista para el mantenimiento',
  returnFromMaintenanceDate: 'Fecha prevista de devolución de mantenimiento',
  warranty: 'Período de garantía',
  expiration: 'Período de expiración',
};

export default formMaintenance;